import FormCheckbox from "../../shared/FormCheckbox";
import FormSelect from "../../shared/FormSelect";

const step = 9
const StepNine = ({ activeStep, control, errors, register, getValues, updateAccumulatorFromMapping }) => {
    if (activeStep !== step) return;

    const dedValue = getValues('accumulator.prescription.inNetwork.deductible.type')
    const oopValue = getValues('accumulator.prescription.inNetwork.outOfPocket.type')

    return (
        <div style={{}}>
            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '1rem 0rem' }}>Prescription Accumulator In-Network</p>
            <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '0rem 0rem 1rem 0rem' }}>Deductible</p>
            <FormSelect
                label={'Deductible Type'}
                name={'accumulator.prescription.inNetwork.deductible.type'}
                control={control}
                options={[
                    { value: 'Aggregate', label: 'Aggregate' },
                    { value: 'Embedded', label: 'Embedded' },
                    { value: 'None', label: 'None' },
                ]}
                errors={errors}
                placeholder="Select..."
                onSelectedHandler={updateAccumulatorFromMapping}
            />

            <div style={{ padding: '0rem 0rem 2rem 0rem', display: 'flex', gap: '2rem' }}>
                <FormCheckbox
                    label={'Prescription INN DED Applies to Prescription OON DED?'}
                    name={`accumulator.prescription.inNetwork.deductible.tierDeductibleSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={dedValue?.value == 'None'}
                />
                <FormCheckbox
                    label={'Prescription INN DED Applies to Medical INN DED?'}
                    name={`accumulator.prescription.inNetwork.deductible.productTypeDeductibleSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={dedValue?.value == 'None'}
                />

            </div>

            {/* <div style={{ display: 'flex', gap: '1rem', padding: '' }}> */}
            {/*     <FormInputNumber name={"accumulator.prescription.inNetwork.deductible.individualAmt"} label={`Individual Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.prescription.inNetwork.deductible.empSpouesChild"} label={`Emp+Spouse | Children Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.prescription.inNetwork.deductible.familyAmt"} label={`Family Amount`} errors={errors} register={register} /> */}
            {/* </div> */}

            <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '2rem 0rem 1rem 0rem' }}>Out-of-Pocket</p>
            <FormSelect
                label={'Out of pocket Type'}
                name={'accumulator.prescription.inNetwork.outOfPocket.type'}
                control={control}
                options={[
                    { value: 'Aggregate', label: 'Aggregate' },
                    { value: 'Embedded', label: 'Embedded' },
                    { value: 'None', label: 'None' }
                ]}
                errors={errors}
                placeholder="Select..."
                onSelectedHandler={updateAccumulatorFromMapping}
            />

            <div style={{ padding: '0rem 0rem 2rem 0rem', display: 'flex', gap: '2rem' }}>
                <FormCheckbox
                    label={'Prescription INN OOP Applies to Prescription OON OOP?'}
                    name={`accumulator.prescription.inNetwork.outOfPocket.tierOutOfPocketSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={oopValue?.value == 'None'}
                />
                <FormCheckbox
                    label={'Prescription INN OOP Applies to Medical INN OOP?'}
                    name={`accumulator.prescription.inNetwork.outOfPocket.productTypeOutOfPocketSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={oopValue?.value == 'None'}
                />
            </div>

            {/* <FormInputNumber name={"accumulator.prescription.inNetwork.outOfPocket.coinsurance"} label={`Coinsurance`} errors={errors} register={register} style={{ maxWidth: '50%' }} /> */}

            {/* <div style={{ display: 'flex', gap: '1rem', }}> */}
            {/*     <FormInputNumber name={"accumulator.prescription.inNetwork.outOfPocket.individualAmt"} label={`Individual Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.prescription.inNetwork.outOfPocket.empSpouesChild"} label={`Emp+Spouse | Children Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.prescription.inNetwork.outOfPocket.familyAmt"} label={`Family Amount`} errors={errors} register={register} /> */}
            {/* </div> */}
        </div>
    )
}

export default StepNine
